import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getSubAgents } from '../../actions/subAgents';
import { SubAgentSearch } from '../../components/SubAgentSearch';
import { SubAgentsError } from '../../components/SubAgentsError';
import { subAgentsSelector } from '../../selectors';
import { ERequestApiStatus } from '../../types/appState';
import { SubAgentSearchInputContainer } from '../SubAgentSearchInputContainer';
import { SubAgentsListContainer } from '../SubAgentsListContainer';

export const SubAgentSearchContainer = () => {
  const { subAgentsList, status, search } = useSelector(subAgentsSelector);

  const isEmptySubAgentsList = subAgentsList?.length === 0;
  const isLoading = status === ERequestApiStatus.Pending;
  const isError = status === ERequestApiStatus.Failed && isEmptySubAgentsList;
  const isEmptySearch = Boolean(status === ERequestApiStatus.Succeed && search && isEmptySubAgentsList);
  const isEmptyList = Boolean(status === ERequestApiStatus.Succeed && !search && isEmptySubAgentsList);
  const isShowInput = !isError && !isEmptyList;

  const dispatch = useDispatch();

  const handleReload = React.useCallback(() => {
    dispatch(getSubAgents({}));
  }, [dispatch]);

  return (
    <SubAgentSearch
      inputNode={isShowInput ? <SubAgentSearchInputContainer /> : null}
      subAgentsNode={<SubAgentsListContainer />}
      isLoading={isLoading}
      isEmptySearch={isEmptySearch}
      isEmptyList={isEmptyList}
      errorNode={isError ? <SubAgentsError onClick={handleReload} /> : null}
    />
  );
};
